import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import PageViewer from "../../../../administration/pods/pageViewer/pageViewer";

function PageView() {
    const params = useParams();

    return (
        <div>
            <PageViewer pageID={params.page.split("+")[0]} />
        </div>
    );
}

export default PageView;
